"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthYearPickers = exports.MonthYearPicker = exports.MonthWrapper = exports.MonthSeparator = exports.CalendarWrapper = exports.CalendarMonthNavigation = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CalendarWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background: ", ";\n  display: inline-flex;\n  flex-direction: column;\n  user-select: none;\n  position: relative;\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  padding: ", " 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.calendarBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.lineHeight;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.calendarHorizontalPadding;
});
exports.CalendarWrapper = CalendarWrapper;
var MonthWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n"])), function (_ref6) {
  var enableMaxWidth = _ref6.enableMaxWidth;
  return enableMaxWidth && "\n    overflow: auto;\n    max-width: 100vw;";
});
exports.MonthWrapper = MonthWrapper;
var MonthSeparator = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: ", ";\n  background: ", ";\n  margin: 0 ", ";\n\n  &:last-child {\n    display: none;\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.monthSeparatorLineWidth;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.monthSeparatorLineColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.monthSeparatorLineMargin;
});
exports.MonthSeparator = MonthSeparator;
var MonthYearPickers = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.calendarMonthYearPickerBottomMargin;
});
exports.MonthYearPickers = MonthYearPickers;
var MonthYearPicker = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.calendarMonthYearPickerVerticalPadding;
});
exports.MonthYearPicker = MonthYearPicker;
var CalendarMonthNavigation = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme,
    showMonthYearPickers = _ref12.showMonthYearPickers;
  if (showMonthYearPickers) {
    return '16px';
  }
  return theme.isClassic ? '10px' : '6px';
}, function (_ref13) {
  var isLeft = _ref13.isLeft;
  return isLeft ? 'left: 6px' : 'right: 6px';
});
exports.CalendarMonthNavigation = CalendarMonthNavigation;
CalendarMonthNavigation.propTypes = {
  isLeft: _propTypes["default"].bool,
  showMonthYearPickers: _propTypes["default"].bool
};
CalendarMonthNavigation.defaultProps = {
  isLeft: false,
  showMonthYearPickers: false
};